import styled from "@emotion/styled";
import { CloseIcon } from "components/Icons";

interface CloseButtonProps {
  closeView: () => void;
}

export const CloseButton = ({ closeView }: CloseButtonProps) => {
  return (
    <CloseButtonContainer onClick={closeView}>
      <CloseIcon width={20} height={20} />
    </CloseButtonContainer>
  );
};

// Sub-components

const CloseButtonContainer = styled.button`
  padding: 10px;
  height: 40px;
  border-radius: 14px;
  background-color: ${props => props.theme.button.tertiary.surface.default};
  color: ${props => props.theme.button.tertiary.text.default};
  border: none;
  box-shadow: 0px 0px 26px 0px #000;
  transition:
    color 250ms linear,
    background-color 250ms linear;

  &:hover {
    background-color: ${props => props.theme.button.tertiary.surface.hover};
    color: ${props => props.theme.button.tertiary.text.hover};
  }
`;
